import React from 'react';
import styled from 'styled-components';

import HeadTitle from '../../components/HeadTitle';
import ContainerPage from '../../components/ContainerPage';

import { ProductList } from './components/ProductList';

import { Button, LoadingOverlay } from '../../components';
import { Resources } from '../../models/ScheduleResource';

const Container = styled.div`
  padding-bottom: 20px;
`;

export type Props = {
  resources: Resources[];
  handleResources: (resources: Resources) => void;
  buttonDisabled?: boolean;
  loading?: boolean;
  goBack?: () => void;
  handleSelectProduct?: (value: Resources) => void;
  headTitle?: string;
  listBottomComponent?: React.ReactNode;
};

export const ResourceSelectorTemplate: React.FC<Props> = ({
  resources,
  buttonDisabled,
  handleResources,
  handleSelectProduct,
  loading,
  headTitle,
  goBack,
  listBottomComponent
}) => {
  const [listProducts, setListProducts] = React.useState<Resources[]>(resources);
  const [selected, setSelected] = React.useState<Resources>();

  const selectProduct = (product: Resources) => {
    setSelected(product);
    handleSelectProduct?.(product);
  };

  React.useEffect(() => {
    if (listProducts.length === 1) selectProduct(listProducts[0]);
  }, [listProducts]);

  return (
    <ContainerPage
      childrenFooter={
        <Button
          title="Continuar"
          disabled={buttonDisabled ?? !selected}
          onClick={() => {
            selected && handleResources(selected);
          }}
        />
      }
    >
      <Container>
        <HeadTitle title={headTitle ?? 'Escolha o produto'} goBack={goBack} />

        <ProductList
          products={listProducts}
          setProductList={setListProducts}
          selected={selected}
          handleSelect={product => selectProduct(product)}
        />
        {listBottomComponent}
      </Container>
      <LoadingOverlay loading={!!loading} />
    </ContainerPage>
  );
};
